export default __webpack_public_path__ + "static/Knockout-51Middleweight-1d555358619da7246a17a67c80733a01.otf";